import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Redirect, Switch } from "react-router-dom";
import Login from "./components/Login";
import ChangePassword from "./components/ChangePassword";
import Forgetpassword from "./components/Forgetpassword";
import Resetpassword from "./components/Resetpassword";
import Unauthorized from "./components/Unauthorized";
import SideMenu from "./components/SideMenu";
import MaintenanceWindow from "./components/MaintenanceWindow";
// import Header from './Header';
import Home from "./components/Home";
//Partner start
import Affiliates from "./components/partner/affiliates";
import Reseller from "./components/partner/Reseller";
import ResellerCustomer from "./components/partner/resellerCustomer";
import ManageReferer from "./components/partner/manageReferer";
import Allreseller from "./components/partner/allreseller";
//End Partner
// customer start
import EnterpriseCustmer from "./components/customer/EnterpriseCustomer";
import CustmerList from "./components/customer/CustomerList";
import LeadsList from "./components/customer/LeadsList";
import MuviFreeList from "./components/customer/MuviFreeList";
import CancelledStoredList from "./components/customer/CancelledStoredList";
import DemoStoreList from "./components/customer/DemoStoreList";
import AllStoreList from "./components/customer/AllStoreList";
import DeletedStoresList from "./components/customer/DeletedStoresList";
import CustomerDetails from "./components/customer/CustomerDetails";
import StoreDetails from "./components/customer/StoreDetails";
import EnterpriseDetails from "./components/customer/EnterpriseDetails";
// Customer end

// 72052 - Feature tagging
import FeatureListing from "./components/feature/FeatureListing";
import AddFeature from "./components/feature/AddFeature";
import EditFeature from "./components/feature/EditFeature";
//End Feature

// Er Start
import Er from "./components/er/Er";
import ErTest from "./components/er/ErTest";
import Kanban from "./components/er/Kanban";
import Snippets from "./components/er/Snippets";
import LiveChat from "./components/er/LiveChat";
import Newanalytics from "./components/analytics/Newanalytics";
import ViewChat from "./components/er/ViewChat";
import ViewSnippet from "./components/er/viewSnippet";
import AddRequest from "./components/er/AddRequest";
import AddTaskEr from "./components/er/AddTaskEr";
import AddEr from "./components/er/AddEr";
import ViewEr from "./components/er/viewEr";
import ViewErTest from "./components/er/viewErTest";
import UpdateEr from "./components/er/updateEr";
import UpdateChat from "./components/er/UpdateChat";
import NoteEdit from "./components/er/NoteEdit";
import CloneEr from "./components/er/cloneEr";
import ManageErFilter from "./components/er/ManageErFilter";
import HistoryRevision from "./components/er/HistoryRevision";
import ViewStory from "./components/er/viewStory";
import NoteStoryEdit from "./components/er/NoteStoryEdit";
import NoteSnippetEdit from "./components/er/NoteSnippetEdit";
import NoteChatEdit from "./components/er/NoteChatEdit";
import StoryHistoryRevision from "./components/er/StoryHistoryRevision";
import SnippetHistoryRevision from "./components/er/SnippetHistoryRevision";
import ChatHistoryRevision from "./components/er/ChatHistoryRevision";
import UpdateStory from "./components/er/updateStory";
import CloneStory from "./components/er/cloneStory";
import UpdateFeatureCategoryEr from "./components/er/updateFeatureCategoryEr";
//support start
import TicketList from "./components/support/TicketList";
import ViewTicket from "./components/support/ViewTicket";
import ViewTicketTest from "./components/support/ViewTicketTest";
import EditTicket from "./components/support/EditTicket";
import HistoryDetails from "./components/support/HistoryDetails";
import AddTicket from "./components/support/AddTicket";
import EditNote from "./components/support/EditNote";
import ManageFilter from "./components/support/ManageFilter";
import AddErTicket from "./components/support/AddErTicket";
//support End
//sla start
import SlaList from "./components/sla/SlaList";
import EditSla from "./components/sla/EditSla";
import AddSla from "./components/sla/AddSla";
import SlaDashboard from "./components/sla/SlaDashboard";
//sla End

// Todo start
import TodoList from "./components/todo/todoList";
import AddTodo from "./components/todo/addTodo";
import ViewTodo from "./components/todo/viewTodo";
import UpdateTodo from "./components/todo/updateTodo";
import TodoHistoryDetails from "./components/todo/todoHistoryDetails";
import todoUnauthorized from "./components/todo/todoUnauthorized";
// Todo end
//okr
import Okr from "./components/todo/okr";

// Revenue Start
import Revenue from "./components/revenue/Revenue";
import DevHour from "./components/revenue/DevHour";
import RevenueReseller from "./components/revenue/RevenueReseller";

// AI related stuff.
import DocumentTraining from "./components/ai/DocumentTraining";
// import BOT from "./components/ai/bot";
import Alie from "./components/ai/ai";
import AlieResponseEval from "./components/ai/AlieResponseEval";

// Infra Start
import Infra from "./components/infra/Infra";

// Help Start
import Help from "./components/help/Help";

//import MyPerform from './components/My Performance/myperform';
//MyPerformance start
import PeerReview from "./components/MyPerformance/peerReview";

// HR Admin start
import ManageEmployee from "./components/hrAdmin/manageEmployee";
import AddEmployee from "./components/hrAdmin/addEmployee";
import ViewEmployee from "./components/hrAdmin/viewEmployee";
import ViewEmployeeNewOne from "./components/hrAdmin/ViewEmployeeNewOne";
import leaveReward from "./components/hrAdmin/leaveReward";
import ViewLeaveReward from "./components/hrAdmin/viewLeaveReward";
import Leave from "./components/hrAdmin/leaves";
import LeavesByEmployee from "./components/hrAdmin/leavesByEmployee";
import LeaveLops from "./components/hrAdmin/leaveLops";
import Reward from "./components/hrAdmin/rewards";
import LeaveRequests from "./components/hrAdmin/leaveRequests";
import Masters from "./components/hrAdmin/masters";
import PerformanceReviews from "./components/hrAdmin/performanceReviews";
import ManageGroups from "./components/hrAdmin/manageGroups";


import EmployeeActivityInsights from "./components/hrAdmin/EmployeeActivityInsights";
import EmployeeActivityInsightsDetails from "./components/hrAdmin/EmployeeActivityInsightsDetails";
//new
import Groups from "./components/hrAdmin/groups";
import GroupDetail from "./components/hrAdmin/GroupDetail";

import Organizationchart from "./components/hrAdmin/organizationchart";
import Orgchart from "./components/hrAdmin/orgchart";
import ViewGroups from "./components/hrAdmin/viewGroups";
import Attendance from "./components/hrAdmin/Attendance";
// HR Admin end

//Okr start
import AddOKR from "./components/okr/addokr";
import Updateokr from "./components/okr/updateokr";
import Listokr from "./components/okr/listokr";
import Editokr from "./components/okr/editokr";
import Viewokr from "./components/okr/viewokr";
import Noteokredit from "./components/okr/noteokredit";
//import ViewOkr from './components/okr/viewokr';
import Okrhistoryrevision from "./components/okr/okrhistoryrevision";
//okr end

// Hiring start
import HiringList from "./components/hiring/hiringList";
import AddCandidate from "./components/hiring/addCandidate";
import ViewCandidate from "./components/hiring/viewCandidate";
import EditCandidate from "./components/hiring/editCandidate";
// Hiring end

//ISMS Quiz Start
import Quiz from "./components/ISMSQuiz/ISMSQuizList";
//ISMS Quiz End

// Advanced start
import ContactUs from "./components/advanced/ContactUs";
import HackaThon from "./components/advanced/HackaThon";
import PdfdownLoads from "./components/advanced/pdfDownloads";
import LivedemoRequests from "./components/advanced/livedemoRequests";
import MigrationRequest from "./components/advanced/MigrationRequest";
import TemplatePurchaseRequest from "./components/advanced/TemplatePurchaseRequest";
import AllProductsRequest from "./components/advanced/AllProductsRequest";
import SanjhRequest from "./components/advanced/SanjhRequest";
import Walkin from "./components/advanced/Walkin";
import PartnerContact from "./components/advanced/PartnerContact";
import Walkindetails from "./components/advanced/Walkindetails";
import Partnercontdetails from "./components/advanced/Partnercontdetails";
import Allwebinar from "./components/advanced/AllwebinarRequest";
import MuviUltimate from "./components/advanced/MuviUltimate";
import AskSales from "./components/advanced/AskSales";
import joinmuvitv from "./components/advanced/joinmuvitv";
import rfp from "./components/advanced/rfp";
import Cookies from "js-cookie";
// Advanced end
//Customer success code[biswajitDas]
import {
	DefaultPage,
	FcmChange,
	PasswordChange,
	StorebillingdateChange,
	UserinfoRemove,
} from "./components/customerSuccess/customerSuccess";
import ChatTranscript from "./components/chat/ChatTranscript";
import ChatDetails from "./components/chat/ChatDetails";
import AddFeedback from "./components/chat/AddFeedback";
//Customer success code[biswajitDas]

//crm
import NewCustomerList from "./components/crm/customer/NewCustomerList";
import Deals from "./components/crm/deals/Deals";
import AddDeal from "./components/crm/deals/AddDeal";
import NewLayoutDesign from "./components/crm/customer/NewLayoutDesign";
import NewLayoutFive from "./components/crm/customer/NewlayoutFive";
import LiveStreamInfo from "./components/crm/livestream/LiveStreamInfo";
import AgGridCustomerListing from "./components/crm/customer/AgGridCustomerListing";
//message
class Routing extends Component {
	constructor(props) {
		super(props);
		this.state = { isLoggedIn: false };
		this.logout = this.logout.bind(this);
	}

	componentWillMount() {
		if (localStorage.getItem("userLogin")) {
			this.setState({ isLoggedIn: true });
		} else if (window.location.pathname != "/login" && window.location.pathname != "/") {
			Cookies.set("redirectPath", window.location.pathname);
		}
		// else{
		//   Cookies.remove('redirectPath');
		// }
	}
	logout() {
		localStorage.setItem("userLogin", "");
		localStorage.clear();
		<Redirect to={"/login"} />;
		window.parent.location = window.parent.location.href;
	}

	render() {
		const isLoggedIn = this.state.isLoggedIn;
		let sidemenu = null;
		if (isLoggedIn) {
			sidemenu = (
				<div className="col-md-3 left_col">
					<div className="nav-overlay hidden-md"></div> <SideMenu />
				</div>
			);
		}
		return (
			<Router>
				<div className="wrapper">
					{sidemenu}
					{/* {Header}   */}
					<div id="content">
						<Switch>
							<Route
								exact
								path="/"
								render={() =>
									this.state.redirect ? <Redirect to="/home" /> : <Redirect to="/login" />
								}
							/>
							<Route
								path={`/changePassword/hashkey/:hashkey/userAuthKey/:userAuthKey`}
								component={ChangePassword}
							/>
							<Route path="/login" component={Login} />
							<Route path="/home" component={Home} />

							{/*AI Related Routes by bikash*/}
							{/* <Route path="/alie" component={BOT} /> */}
							<Route path="/alie" component={Alie} />
				            <Route path="/eval" component={AlieResponseEval} />
							<Route path="/train" component={DocumentTraining} />


							{/*5.03.19 by kalyani*/}

							<Route path="/Forgetpassword" component={Forgetpassword} />
							<Route path={`/Resetpassword/hashkey/:hashkey`} component={Resetpassword} />

							<Route path="/ticketstest" component={TicketList} />
							<Route path="/addticket" component={AddTicket} />
							<Route path="/ManageFilter" component={ManageFilter} />
							<Route path={`/ticket/viewTicket/id/:ticketId`} component={ViewTicket} />
							<Route path={`/ticket/ViewTicketTest/id/:ticketId`} component={ViewTicketTest} />
							<Route path={`/editTicket/:ticketId`} component={EditTicket} />
							<Route path={`/ticket/editNote/:noteId`} component={EditNote} />
							<Route path={`/HistoryDetails/:ticketId`} component={HistoryDetails} />
							{/* <Route path={`/AddErTicket/:ticketId`} component={AddErTicket} /> */}
							{/*<Route path={`/AddErTicket/:ticketId/:tattleId?`} component={AddErTicket} /> */}
							<Route path={`/AddErTicket/:ticketId`} component={AddErTicket} />

							<Route path="/SlaList" component={SlaList} />
							<Route path="/EditSla/:slaId" component={EditSla} />
							<Route path="/AddSla" component={AddSla} />
							<Route path="/SlaDashboard" component={SlaDashboard} />

							{/* 72052-Feature Tagging */}
							<Route path={`/features`} component={FeatureListing} />
							<Route path={`/feature/add`} component={AddFeature} />
							<Route path={`/feature/view/:feature_id`} component={EditFeature} />
							<Route path="/chats/list" component={ChatTranscript} />

							<Route path="/test/detail/:studioId(\d+)" component={CustomerDetails} />
							<Route path="/test/detail/:appToken" component={StoreDetails} />

							<Route path="/test/enterpriseCustomers" component={EnterpriseCustmer} />
							<Route path="/test/customers" component={CustmerList} />
							<Route path="/viewDetail/:studioId" component={CustomerDetails} />

							{/* CRM ROUTING START */}
							<Route path="/customer/list" component={NewCustomerList} />
							<Route path="/accounts/list" component={AgGridCustomerListing} />
							<Route path="/account/:studioId(\d+)" component={NewLayoutFive} />
							<Route path="/account/:appToken([a-zA-Z0-9]{6,})" component={NewLayoutDesign} />
							<Route path="/stream/info" component={LiveStreamInfo} />
							<Route path="/deals/list" component={Deals} />
							<Route path="/deal/:deal_uuid" component={AddDeal} />
							<Route path="/deals/add" component={AddDeal} />
							{/* CRM ROUTING END */}

							<Route path="/test/leads" component={LeadsList} />
							<Route path="/muvifree" component={MuviFreeList} />
							<Route path="/test/cancelledStores" component={CancelledStoredList} />
							<Route path="/test/demoStores" component={DemoStoreList} />
							<Route path="/test/allStores" component={AllStoreList} />
							<Route path="/test/deletedStores" component={DeletedStoresList} />
							<Route path="/EnterpriseDetails/:studioId/type/:type" component={EnterpriseDetails} />

							<Route path="/contactUs" component={ContactUs} />
							<Route path="/hackathon" component={HackaThon} />
							<Route path="/pdfDownloads" component={PdfdownLoads} />
							<Route path="/livedemorequests" component={LivedemoRequests} />
							<Route path="/migrationrequest" component={MigrationRequest} />
							<Route path="/templatepurchaserequest" component={TemplatePurchaseRequest} />
							<Route path="/allproductsrequest" component={AllProductsRequest} />
							<Route path="/sanjhrequest" component={SanjhRequest} />
							<Route path="/walkin" component={Walkin} />
							<Route path="/partnerContact" component={PartnerContact} />
							<Route path={`/Walkindetails/:id`} component={Walkindetails} />
							<Route path={`/Partnercontdetails/:id`} component={Partnercontdetails} />
							<Route path={`/AllwebinarRequest`} component={Allwebinar} />
							<Route path={`/MuviUltimate`} component={MuviUltimate} />
							<Route path={`/ask-sales/list`} component={AskSales} />
							<Route path={`/joinmuvitv`} component={joinmuvitv} />
							<Route path={`/rfp`} component={rfp} />

							<Route path="/reseller" component={Reseller} />
							<Route path="/managereferer" component={ManageReferer} />
							<Route path={`/resellerCustomer/:id`} component={ResellerCustomer} />
							<Route path="/allreseller" component={Allreseller} />
							<Route path="/affiliates" component={Affiliates} />

							<Route path="/revenue" component={Revenue} />
							<Route path="/devhour" component={DevHour} />
							<Route path="/revenueReseller" component={RevenueReseller} />

							<Route path="/infra" component={Infra} />

							<Route path="/analytics" component={Newanalytics} />
							<Route path="/er" component={Er} />
							<Route path="/erTest" component={ErTest} />
							<Route path="/kanban" component={Kanban} />
							<Route path="/snippets" component={Snippets} />
							<Route path="/liveChat" component={LiveChat} />
							<Route path={`/viewChat/:transcript_id`} component={ViewChat} />
							<Route path={`/viewSnippet/:snippetId`} component={ViewSnippet} />
							<Route path="/addrequest" component={AddRequest} />
							<Route path={`/AddTaskEr`} component={AddTaskEr} />
							<Route path="/AddEr/:erId" component={AddEr} />
							<Route path={`/viewEr/:erId`} component={ViewEr} />
							<Route path={`/viewErTest/:erId`} component={ViewErTest} />
							<Route path={`/EditEr/:erId`} component={UpdateEr} />
							<Route path={`/EditChat/:transcriptId`} component={UpdateChat} />
							<Route path={`/NoteEdit/:noteId`} component={NoteEdit} />
							<Route path={`/cloneEr/:erId`} component={CloneEr} />
							<Route path="/ManageErFilter" component={ManageErFilter} />
							<Route path={`/HistoryRevision/:erId/type/:type/rev/:noteid`} component={HistoryRevision} />
							<Route path={`/viewStory/:storyId/sequence/:seqNo`} component={ViewStory} />
							<Route path={`/NoteStoryEdit/:noteStoryId/sequence/:seqNo`} component={NoteStoryEdit} />
							<Route path={`/NoteSnippetEdit/:snippetId`} component={NoteSnippetEdit} />
							<Route path={`/NoteChatEdit/:transcriptId`} component={NoteChatEdit} />
							<Route
								path={`/StoryHistoryRevision/:storyId/type/:type/rev/:noteid`}
								component={StoryHistoryRevision}
							/>
							<Route
								path={`/SnippetHistoryRevision/:snippetId/noteId/:noteId`}
								component={SnippetHistoryRevision}
							/>
							<Route
								path={`/ChatHistoryRevision/:transcriptId/noteId/:noteId`}
								component={ChatHistoryRevision}
							/>
							<Route path={`/EditStory/:storyId/sequence/:seqNo`} component={UpdateStory} />
							<Route path={`/cloneStory/:storyId/sequence/:seqNo`} component={CloneStory} />
							<Route path={`/EditFeatureCategoryEr/:erId`} component={UpdateFeatureCategoryEr} />

							<Route path="/help" component={Help} />

							<Route path="/peer-review" component={PeerReview} />

							<Route path="/todos" component={TodoList} />
							<Route path="/addtodo" component={AddTodo} />
							<Route path={`/viewTodo/:todoId`} component={ViewTodo} />
							<Route path={`/updateTodo/:todoId`} component={UpdateTodo} />
							<Route path={`/TodoHistoryDetails/:todoId`} component={TodoHistoryDetails} />
							<Route path="/okr" component={Okr} />
							<Route path="/Unauthorized" component={todoUnauthorized} />

							<Route path="/employees" component={ManageEmployee} />
							<Route path="/addEmployee" component={AddEmployee} />

							<Route exact path="/activity/insights/" component={EmployeeActivityInsights} />
							<Route path="/activity/insights/details" component={EmployeeActivityInsightsDetails} />

							<Route path="/viewEmployee/:employeeId/:user_uuid?" component={ViewEmployee} />
							<Route path="/viewEmployeeNewOne/:employeeId" component={ViewEmployeeNewOne} />
							{/* <Route path="/viewEmployee/:employeeId" component={ViewEmployee} /> */}
							<Route path="/leaveReward" component={leaveReward} />
							<Route path="/viewLeaveReward/:employeeId" component={ViewLeaveReward} />
							<Route path="/leaves" component={Leave} />
							<Route path="/leavesByEmployee" component={LeavesByEmployee} />
							<Route path="/leaveLops" component={LeaveLops} />
							<Route path="/rewards" component={Reward} />
							<Route path="/leaveRequests" component={LeaveRequests} />
							<Route path="/masters" component={Masters} />
							<Route path="/performanceReviews" component={PerformanceReviews} />
							<Route path="/manageGroups" component={ManageGroups} />

							<Route path="/groups" component={Groups} />

							<Route path="/organizationchart" component={Orgchart} />
							<Route path="/viewGroups/:groupId" component={GroupDetail} />
							<Route path="/Attendance" component={Attendance} />

							<Route path="/listokr" component={Listokr} />
							<Route path={`/editokr/:id`} component={Editokr} />
							<Route path="/addokr" component={AddOKR} />
							<Route path={`/viewokr/:id`} component={Viewokr} />
							<Route path={`/updateokr/:id`} component={Updateokr} />
							<Route path={`/noteokredit/:id`} component={Noteokredit} />
							{/*<Route path={`/viewokr/:id`} component={ViewOkr} />*/}
							<Route path={`/okrhistoryrevision/:id/noteId/:noteId`} component={Okrhistoryrevision} />

							{localStorage.getItem("quizExpireStatus") == 1 ? (
								<Route path="/Quiz" component={Quiz} />
							) : (
								""
							)}

							<Route path="/hiring" component={HiringList} />
							<Route path="/chat/:id" exact component={ChatDetails} />
							<Route path="/chats" component={ChatTranscript} />
							<Route path="/idea/:id" component={AddFeedback} />
							<Route path="/addHiring" component={AddCandidate} />
							<Route path="/viewCandidate/:candidateId" component={ViewCandidate} />
							<Route path="/editCandidate/:candidateId" component={EditCandidate} />
							<Route path="/customerSuccess/PasswordChange" component={PasswordChange} />
							<Route path="/customerSuccess/DefaultPage" component={DefaultPage} />
							<Route path="/customerSuccess/FcmChange" component={FcmChange} />
							<Route path="/customerSuccess/StorebillingdateChange" component={StorebillingdateChange} />
							<Route path="/customerSuccess/UserinfoRemove" component={UserinfoRemove} />
							<Route path="/maintenanceWindow" component={MaintenanceWindow} />
							<Route path="*" component={Unauthorized} />
						</Switch>
					</div>
				</div>
			</Router>
		);
	}
}
export default Routing;



// WEBPACK FOOTER //
// ./src/Routing.js